import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { MenuCategoriesItem } from "./MenuCategoriesItem";
import EditCategoryModal from "./EditCategoryModal";
import {onCategoriesEdit, onCategoriesModalEdit} from "../../store/Categories/actions";
import {useParams} from "react-router";
import {useEditCategory} from "../../network";

export const MenuCategories = ({ onOpenEditCategory, filteredCategory }) => {
    const [state, setState] = useState([]);

    useEffect(() => setState(filteredCategory), [filteredCategory]);

    if (!state || (state && !state.length)) return null;

    return (
        <div>
            {state.map((category) => (
                <MenuCategoriesItem
                    key={category.id}
                    category={category}
                    onOpenEditCategory={onOpenEditCategory}
                />
            ))}
        </div>
    );
};

const Categories = ({ loading, modalEditCategory, filteredCategory }) => {
    const { slug } = useParams();
    const dispatch = useDispatch();
    const [category, setCategory] = useState({});
    const { mutate: editCategory, isLoading } =  useEditCategory({ slug })

    const onOpenEditCategory = (category) => {
        setCategory(category);
        dispatch(onCategoriesModalEdit(true));
    };
    const onCloseEditCategory = () => {
        setCategory({});
        dispatch(onCategoriesModalEdit(false));
    };
    const onChangeEditCategoryName = (e) => { setCategory({ ...category, name: e.target.value })};
    const onSaveEditCategory = () => {
        editCategory({ category })
        onCloseEditCategory()
    };
    const onArchived = () => {
        editCategory({ category, archived: true })
        onCloseEditCategory()
    };
    const onUnArchived = () => {
        onSaveEditCategory();
        onCloseEditCategory()
    };

    return (
        <>
            <MenuCategories
                filteredCategory={filteredCategory}
                onOpenEditCategory={onOpenEditCategory}
            />
            <EditCategoryModal
                loading={isLoading}
                category={category}
                visible={modalEditCategory}
                onClose={onCloseEditCategory}
                onChangeName={onChangeEditCategoryName}
                onSave={onSaveEditCategory}
                onArchived={onArchived}
                onUnArchived={onUnArchived}
            />
        </>
    );
};

export default Categories;
